import Styled from 'styled-components'
import Media from 'styled-media-query'

export default Styled.h3`
  text-align: center;
  font-size: 1.25rem;
  margin: 0;
  color: ${props => props.theme.colors.primary.shade400};

  ${Media.greaterThan('medium')`
    font-size: 1.5rem;
  `}
`



// WEBPACK FOOTER //
// ./src/components/AuthTitle/index.js